/**
 * MEETING API — Wrapper REST allineato a MeetingsResourceImpl.java.
 * I 5 metodi CRUD standard vengono da `createCrudApi`.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET    /meetings/{groupId}?status=&search=&page=&pageSize=  -> Page<Meeting>
 *   - POST   /meetings/{groupId}  MeetingInput                     -> Meeting
 *   - GET    /meeting/{meetingId}                                   -> Meeting
 *   - PATCH  /meeting/{meetingId} MeetingInput                     -> Meeting
 *   - DELETE /meeting/{meetingId}                                   -> 200
 *
 * A differenza di Call non c'e' `direction` nel path: la list e' singola con
 * filtri status/search. `meetingUpdateToInput` ignora `meetingId` (whitelist).
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudApi } from '../../store/createCrudApi';
import {
  meetingFromDto,
  meetingCreateToInput,
  meetingUpdateToInput,
  type MeetingDto,
} from './meetingMappers';
import type { Meeting, MeetingCreatePayload, MeetingStatus, MeetingUpdatePayload } from './meetingTypes';

export interface MeetingListParams extends ServerListParams {
  status?: MeetingStatus;
}

export const meetingApi = createCrudApi<
  Meeting,
  MeetingDto,
  MeetingCreatePayload,
  MeetingUpdatePayload,
  MeetingListParams
>({
  collection: '/meetings',
  single: '/meeting',
  fromDto: meetingFromDto,
  createToInput: meetingCreateToInput,
  updateId: (p) => p.meetingId,
  updateToInput: (p) => meetingUpdateToInput(p),
});
